import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRedirect, DomainRoute } from '../utils/domain/routingComponents'
import { marketingToolingAdminAccessControl } from '../access-control/marketingToolingAdminAccess.configuration'

const ListPage = lazy(() => import('../pages/admin/AdminListPage'))
const CreatePage = lazy(() => import('../pages/admin/AdminCreatePage'))
const EditPage = lazy(() => import('../pages/admin/AdminEditPage'))
const ViewPage = lazy(() => import('../pages/admin/AdminViewPage'))
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const marketingToolingAdminRouter = (
  <DomainRoute
    route="app-admin-marketing-tooling-campaigns"
    accessControl={marketingToolingAdminAccessControl}
  >
    <DashSwitch>
      <DomainRoute exact route="app-admin-marketing-tooling-campaigns" component={ListPage} />
      <DomainRoute
        exact
        route="app-admin-marketing-tooling-campaigns-create"
        component={CreatePage}
      />
      <DomainRoute exact route="app-admin-marketing-tooling-campaigns-edit" component={EditPage} />
      <DomainRoute exact route="app-admin-marketing-tooling-campaigns-view" component={ViewPage} />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}

      {/* Redirect to the list page by default */}
      <DomainRedirect toRoute="app-admin-marketing-tooling-campaigns" />
    </DashSwitch>
  </DomainRoute>
)
